import Crud from '../views/Department/Crud'
import Entity from '../views/Department/Add'


let routes = {
    path: '/departments',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/departments/add',
            name: 'NewDepartment',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de Departamento',
                breadcrumb: [
                    {
                        text: 'Tipos de Departamento',
                        active: false,
                        to: '/departments',
                    },
                    {
                        text: 'Adicionar tipo de Departamento',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/departments/edit/:id?',
            name: 'EditDepartment',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de Departamento',
                breadcrumb: [
                    {
                        text: 'Tipos de Departamento',
                        active: false,
                        to: '/departments',
                    },
                    {
                        text: 'Editar tipo de Departamento',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/departments',
            name: 'list-departments',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Tipos de Departamento',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
